import React from 'react';
import './modal-form.scss';
import { Button, ButtonColor, ButtonType, ButtonVariant } from '@ampol/design-system';

/**
 * An all-purpose action modal container
 * @param children Child | child[] component(s) child to be rendered inside this modal
 * @param submitClick Submit form event
 * @param closeForm close form event
 * @param title Title of the form
 * @param inModal Is form inside a modal
 * @param submitLabel Submit button label override [Default = Submit]
 * @param cancelLabel Cancel button label override [Default = Cancel]
 * @param canSubmit Is Submit button enabled
 * @param formId Id of the associated form
 * @param isCancelVisible Display cancel button
 * @returns JSX Element
 */
const ModalForm = ({ 
  submitClick, 
  closeForm, 
  inModal, 
  canSubmit, 
  formId, 
  submitLabel='Submit', 
  cancelLabel='Cancel',
  isCancelVisible=true, 
  isSubmitVisible=true, 
  submitColor=ButtonColor.Black, 
  cancelColor=ButtonColor.Black, 
  ...props 
}) => {

  // eslint-disable-next-line react/display-name
  const CancelButton = ({ label, onClick, formId }) => (
    <Button
      type={ButtonType.Reset}
      variant={ButtonVariant.Secondary}
      color={cancelColor}
      label={label}
      onClick={onClick}
      formId={formId}
    />
  );

  // eslint-disable-next-line react/display-name
  const SubmitButton = ({ label, onClick, disabled, formId }) => (
    <Button
      type={ButtonType.Submit}
      variant={ButtonVariant.Primary}
      color={submitColor}
      label={label}
      onClick={onClick}
      inactive={disabled}
      formId={formId}
    />
  );

  return <>
    <div className="modal-form">
      <div className="modal-form__container">
        {props.children}
      </div>
      <div className={`modal-form__actions ${inModal ? 'modal-form__actions--left' : ''}`}>
        {isCancelVisible && !inModal && <CancelButton label={cancelLabel} onClick={closeForm} formId={formId} />}
        {isSubmitVisible && !inModal && <SubmitButton label={submitLabel} onClick={submitClick} disabled={!canSubmit} formId={formId}/>}
      </div>
    </div>
  </>;
};

export default ModalForm;
